import { useQuery } from "@tanstack/react-query"
import { fetcher } from "../fetcher"
import type { Amount } from "./useTransactionPaymentRequestDetails"

export type PaymentRequestPaymentMethod = "A2A" | "Card" | "CardAuth"

export type TransactionPaymentRequestAllowedMethodsApiResponse = {
  externalPaymentRequestId: Amount
  amount: Amount
  cardAmount: Amount | null
  paymentMethod: PaymentRequestPaymentMethod
  referenceId: string | null
  allowedPaymentMethods: PaymentRequestPaymentMethod[]
  blockedCardBrands?: string[] | null
  cardPaymentMethods: {
    id: string
    type: "card"
    brand: string
    last4: string
    expMonth: number
    expYear: number
    isExpired: boolean
  }[]
  cardAccountId: string
  publishableKey: string
  status: string
  oneTimePayment?: boolean
}

type HookParams = {
  paymentRequestId: string
}

export function useTransactionPaymentRequestAllowedMethods({ paymentRequestId }: HookParams) {
  return useQuery<TransactionPaymentRequestAllowedMethodsApiResponse>({
    queryKey: [`paymentRequest/${paymentRequestId}/allowedMethods`],
    queryFn: async () => {
      const response = await fetcher(
        `/Transaction/PaymentRequest/${paymentRequestId}/AllowedMethods`,
        {
          method: "GET",
        },
        {
          useAccessToken: true,
          doNotLogOutOn401: true,
        }
      )
      return response.json()
    },
  })
}
